import { useMemo } from 'react';
import FJTab from '../../../common/components/FJTab/FJTab';
import styles from './FJDisplayHeader.module.less';
// import CreationsIcon from '../../../assets/svg/image-small.svg?react';
// import HistoryIcon from '../../../assets/svg/history.svg?react';
// import ImageExtenderIcon from '../../../assets/svg/image-1.svg?react';
import FJConstant from '../../../constants/FJConstant';
import PropTypes from 'prop-types';
import FJAppConstant from '../../../constants/FJAppConstant';
import classNames from 'classnames';

const FJDisplayHeader = props => {
    const {
        appType,
        onTabChange,
        selectedIndex,
        leftChildren,
        rightChildren,
        hideBottomLine = false,
        isPreDomNotPaddingBox = false,
        className,
    } = props;

    const HEADER_TAB = useMemo(() => {
        return [
            {
                type: FJConstant.CREATIONS,
                text: 'creations',
                // icon: <CreationsIcon />,
                isShow: true,
            },
            {
                type: FJConstant.IMAGE_EXTENDER,
                text: 'generations',
                // icon: <ImageExtenderIcon />,
                isShow: appType === FJAppConstant.IMAGE_EXTENDER,
            },
            {
                type: FJConstant.HISTORY,
                text: 'history',
                // icon: <HistoryIcon />,
                isShow: true,
            },
        ];
    }, [appType]);

    const headerTab = useMemo(() => {
        return HEADER_TAB.filter(item => item.isShow);
    }, []);

    return (
        <div
            className={classNames(
                styles.header,
                {
                    [styles.not_padding_box]: isPreDomNotPaddingBox,
                    [styles.hide_bottom_line]: hideBottomLine,
                },
                className,
            )}
        >
            <div
                className={classNames(
                    styles.header_left,
                    appType === FJAppConstant.IMAGE_EXTENDER || appType === FJAppConstant.IMAGE_TO_IMAGE
                        ? styles.image_extender_header_left
                        : '',
                )}
            >
                {leftChildren}
            </div>
            <FJTab
                dataList={headerTab}
                selectedIndex={selectedIndex}
                space={16}
                onChange={onTabChange}
                lineClass={styles.header_line}
            />
            <div className={styles.header_right}>{rightChildren}</div>
        </div>
    );
};
FJDisplayHeader.propTypes = {
    appType: PropTypes.string,
    selectedIndex: PropTypes.number,
    onTabChange: PropTypes.func,
    hasStatus: PropTypes.bool,
    leftChildren: PropTypes.node,
    rightChildren: PropTypes.node,
    hideBottomLine: PropTypes.bool,
    isPreDomNotPaddingBox: PropTypes.bool,
    className: PropTypes.string,
};
export default FJDisplayHeader;
